import AbstractComponent from "./absctract-component";
import {getUserRating} from "../utils";

export default class Profile extends AbstractComponent {
  constructor(films) {
    super();
    this._userRating = getUserRating(films);
  }

  getTemplate() {
    return `
      <section class="header__profile profile">
        <p class="profile__rating">${this._userRating}</p>
        
        <img class="profile__avatar" src="images/bitmap@2x.png" alt="Avatar" width="35" height="35">
      </section>
    `.trim();
  }
}
